import { ChangeDetectionStrategy, Component, Input } from "@angular/core";
import { LocalComponentStore } from "@dtm-frontend/shared/utils";

interface News10ComponentState {
    activeLanguage: string | undefined;
}

@Component({
    selector: "dtm-main-page-lib-news-10",
    templateUrl: "./news-10.component.html",
    styleUrls: ["./news-10.component.scss"],
    changeDetection: ChangeDetectionStrategy.OnPush,
    providers: [LocalComponentStore],
})
export class News10Component {
    @Input() public set activeLanguage(value: string | undefined) {
        this.localStore.patchState({ activeLanguage: value });
    }

    protected readonly activeLanguage$ = this.localStore.selectByKey("activeLanguage");

    constructor(private readonly localStore: LocalComponentStore<News10ComponentState>) {
        localStore.setState({ activeLanguage: undefined });
    }
}
